import { Button, Flex, Heading, Text, VStack } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { DealsContainer } from '../components/LandingPageComponents/styles/SplashStyles';

const Deals = () => {
    const navigate = useNavigate();
    return (
        <DealsContainer>
            <Flex
                w="full"
                h="full"
                justify="center"
                alignItems="center"
                justifyContent="start"
                flexDir="column">
                <Heading
                    as="h2"
                    w="90%"
                    mt="20px"
                    mb="5px"
                    color="#090A0A"
                    fontSize="24px"
                    textAlign="center"
                    lineHeight="32px">
                    Join Obana Today & Get Commission on each sale
                </Heading>{' '}
                <Text
                    w="80%"
                    mt="1rem"
                    mb="2rem"
                    textAlign="center"
                    fontSize="14px"
                    lineHeight="20px">
                    Take the first step towards a healthier and happier life.{' '}
                </Text>
                <VStack minW="85%" borderRadius="16px" p="1rem" minH="291px" bg="white">
                    <Text
                        textTransform="uppercase"
                        mt="1rem"
                        textAlign="center"
                        fontSize="12px"
                        lineHeight="16px">
                        Popular
                    </Text>
                    <Heading
                        as="h4"
                        mt="0"
                        mb="5px"
                        color="#090A0A"
                        fontSize="18px"
                        textAlign="center"
                        lineHeight="24px">
                        Obana Commissions
                    </Heading>
                    <Heading
                        as="h4"
                        mt="10px"
                        mb="5px"
                        color="#1b3b5f"
                        fontSize="48px"
                        textAlign="center"
                        lineHeight="56px">
                        25-30%
                    </Heading>
                    <Text
                        textAlign="center"
                        opacity=".55"
                        fontSize="14px"
                        lineHeight="20px"
                        pb="1rem">
                        On Every Sale
                    </Text>

                    <Button
                        className="btn"
                        onClick={() => navigate('/pre-offers', { replace: true })}>
                        Proceed to Get Started
                    </Button>
                </VStack>
            </Flex>
        </DealsContainer>
    );
};

export default Deals;
